module.exports = __webpack_public_path__ + "static/media/networks.ec019f89.svg";